// export default {
//   container: {
//     // position: 'relative',
//     // display: 'flex',
//     // alignItems: 'center',
//     // justifyContent: 'center',
//   },
//   image: {
//     // width: 'inherit',
//     // height: 'inherit',
//     ':hover': {
//       opacity: 0.2,
//     },
//   },
//   upload: {
//     position: 'absolute',
//     // left: 0,
//     // right: 0,
//     // top: 0,
//     // bottom: 0,
//     display: 'block',
//     margin: 'auto',
//     borderRadius: 30,
//     backgroundColor: 'white',
//   },
//   fileInput: {
//     display: 'none',
//   },
// };

export default {
  container: {
    position: 'relative',
    width: 300,
    height: 300,
    margin: 'auto',
  },
  body: {
    padding: 25,
  },
  upload: {
    position: 'absolute',
    width: 100,
    height: 100,
    top: 100,
    left: 100,
    zIndex: 100,
  },
  imageContainerStyle: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    // height: this.props.height || 150,
    // width: this.props.width || 150,
  },
  image: {
    objectFit: 'contain',
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  fileInput: {
    display: 'none',
  },

};



// WEBPACK FOOTER //
// ./src/components/Common/ImageUpload/styles.js